<div class="__new__header__bottom __new__header__top2024" (mouseleave)="hideMenu()">
  <div class="section">
    <div class="__new__header__bottom-inner">
      <div>
        <!--mobile menu control-->
        <div class="__new__header__mobile-button js-header-menu-adaptive" [class.active]="mobileOpenMenu">
          <div class="__new__header__mobile-button__icon" (click)="showMobileMenu()">
            <img ngSrc="./img/design/common/header/hamburger.svg" alt="Меню" width="40" height="40">
          </div>
          <div class="__new__header__mobile-button__icon __new__header__mobile-button__icon--closet" (click)="hideMenuMobile()">
            <img ngSrc="./img/design/common/header/header-more-close.svg" alt="Меню" width="40" height="40">
          </div>
          <div class="__new__header__mobile-button__text">Меню</div>
        </div>

        <!--Header menu-->
        <div class="__new__header__menu" *ngIf="!isMobile()">
          <ng-container *ngFor="let menuItem of commonMenu; index as i">
            <ng-container *ngIf="i !== 0">
              <ng-container *ngIf="isOnly(menuItem); else commonHrefBlock">
                <a href="{{ menuItem.href }}" (click)="showMenu(menuItem.id)"
                   class="__new__header__menu-link __new__header__menu-link--desk">{{ menuItem.title }}</a>
              </ng-container>
              <ng-template #commonHrefBlock>
                <a href="{{ menuItem.href }}"
                   class="__new__header__menu-link __new__header__menu-link--desk js-header-menu-link"
                   [attr.data-menu]="menuItem.id">{{ menuItem.title }}</a>
              </ng-template>
            </ng-container>
          </ng-container>

          <!--Иконка для дополнительного меню-->
          <div class="__new__header__menu-more__outer" (click)="showMenu('more')">
            <div
              class="__new__header__menu-more js-header-menu-more"
              [ngClass]="{'active': subMenuMap.get('more')?.open}"
              data-menu="more">
              <!-- SVG ... -->
              <svg
                width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="__new__header__menu-more__icon __new__header__menu-more__icon--dotted"
                [ngStyle]="{'opacity': subMenuMap.get('more')?.open ? 0 : 1}">
                <path d="M11 23C12.6569 23 14 21.6569 14 20C14 18.3431 12.6569 17 11 17C9.34315 17 8 18.3431 8 20C8 21.6569 9.34315 23 11 23Z" fill="#2F2F2F"/>
                <path d="M23 20C23 21.6569 21.6569 23 20 23C18.3431 23 17 21.6569 17 20C17 18.3431 18.3431 17 20 17C21.6569 17 23 18.3431 23 20Z" fill="#2F2F2F"/>
                <path d="M32 20C32 21.6569 30.6569 23 29 23C27.3431 23 26 21.6569 26 20C26 18.3431 27.3431 17 29 17C30.6569 17 32 18.3431 32 20Z" fill="#2F2F2F"/>
              </svg>
              <!-- SVG X -->
              <svg
                width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="__new__header__menu-more__icon __new__header__menu-more__icon--close"
                [ngStyle]="{'opacity': subMenuMap.get('more')?.open ? 1 : 0}">
                <path d="M27.778 26.3638L21.4141 19.9999L27.778 13.6359L26.3638 12.2217L19.9999 18.5856L13.6359 12.2217L12.2217 13.6359L18.5856 19.9999L12.2217 26.3638L13.6359 27.778L19.9999 21.4141L26.3638 27.778L27.778 26.3638Z" fill="#2F2F2F"/>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div class="__new__header__bottom-calls__outer">
        <a href="tel:+74959884422" class="__new__header__bottom-calls__phone">+7 (495) 988-44-22</a>

        <!--Форма обратного звонка - начало -->
        <a (click)="showCalltouchWidget()" class="__new__header__bottom-calls__me">
          Заказать звонок
          <img src="/assets/images/svg/call-order.svg" alt="Заказать звонок" width="16" height="16" class="__new__header__bottom-calls__me--icon">
        </a>
        <!--Форма обратного звонка - конец -->
      </div>
    </div>
  </div>

  <!--Header submenu-->
  <div class="__new__header__submenu js-header-sub-menu {{ subMenuActiveClass }}">
    <div class="section">
      <ng-container *ngFor="let column of subMenuMap | keyvalue">
        <div class="__new__header__submenu-inner {{ isActive(column.value) }}" id="{{ column.key }}" [attr.data-menu]="column.key">
          <div class="__new__header__submenu-menu {{column.value.open}}">

            <!--Возможно, вынести отдельно для мобильного меню -->
            <ng-container *ngIf="isMobile(); else notMobileBlock">
              <div class="__new__header__submenu-column">
                <ng-container *ngFor="let subMenuItem of column.value.subMenu; index as i">
                  <ng-container *ngIf="i === 0">
                    <ng-container *ngFor="let subItem of subMenuItem">
                      <ng-container *ngIf="subItem.bold">
                        <a href="{{ subItem.href }}" class="__new__header__submenu-link">{{ subItem.title }}</a>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>

            <ng-template #notMobileBlock>
              <ng-container *ngFor="let subMenuItem of column.value.subMenu">
                <div class="__new__header__submenu-column">
                  <ng-container *ngFor="let item of subMenuItem">
                    <a href="{{ item.href }}" class="__new__header__submenu-link {{ getBoldClass(item.bold) }}">{{ item.title }}</a>
                  </ng-container>
                </div>
              </ng-container>
            </ng-template>
          </div>

          <a href="/zastrojshhikam" class="__new__header__submenu-banner">
            <div class="submenu-banner__inner">
              <div class="submenu-banner__description">
                <div class="submenu-banner__description-title">Застройщикам</div>
                <div class="submenu-banner__description-text">Увеличим продажи<br/>и стоимость<br/>вашего объекта</div>
              </div>
              <div class="button button__submenu-banner button--size-32">Подробнее</div>
            </div>
          </a>
        </div>
      </ng-container>
    </div>

    <!--Header tablet menu-->
    <!--Header mobile menu-->
  </div>

</div>
<div class="__new__header__mobile-menu __new__header__top2024">
  <div class="__new__header__mobile-menu-shadow js-header-mobile-shadow {{ mobileSubMenuActiveClass }}"></div>
  <div class="__new__header__mobile-menu-outer js-header-mobile-content {{ mobileSubMenuActiveClass }}">
    <div class="__new__header__mobile-menu-inner">
      <ng-container *ngFor="let commonMenuItem of commonMenu">
        <ng-container *ngIf="!!getSubMenuColumn(commonMenuItem.id); else singleMenuLink">
          <div class="__new__header__mobile-menu-title js-header-mobile-title" [attr.data-menu]="commonMenuItem.id"
               (click)="showMobileSubMenu(commonMenuItem.id, $event)"
          >
            {{ commonMenuItem.title }}
          </div>
          <div class="__new__header__submenu-inner" [ngClass]="{ 'active': mobileSubmenuState[commonMenuItem.id] }">
            <div class="__new__header__submenu-menu">
              <div class="__new__header__submenu-column">
                <ng-container *ngFor="let subMenuItem of getSubMenuColumn(commonMenuItem.id)">
                  <ng-container *ngFor="let subItem of subMenuItem">
                    <ng-container *ngIf="subItem.bold">
                      <a href="{{ subItem.href }}" class="__new__header__submenu-link">{{ subItem.title }}</a>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #singleMenuLink>
          <div class="__new__header__mobile-menu-title js-header-mobile-title" [attr.data-menu]="commonMenuItem.id">
            <a href="{{ commonMenuItem.href }}" class="__new__header__mobile-menu-title">{{ commonMenuItem.title }}</a>
          </div>
        </ng-template>

      </ng-container>
    </div>
  </div>
</div>


